import React, { useReducer, useEffect, useState } from 'react';

import { WebStorageStateStore } from "oidc-client-ts";
import { Routes, Route, Link, Outlet } from "react-router";
//import { LayoutLocal } from './LayoutLocal';

//import { getEnvVal } from '#src';
import {
  ContentLayout, 
  setupInitState,
  createInitState,
  appReducer,
  Header,
  getUpapState,
  manageUpap
} from 'clnt-common';

import {
  themes,
  //getEnvMap,
  loadEnvVar,
} from '#src';

import { siteData } from './data/siteData';
import { RouterProvider } from 'react-router'
import { BrowserRouter } from "react-router";
import { StaticRouter } from "react-router";

// NOTE: global.css is included in index.html as <link>

//
// Req'd for oidc
//
const getRandomInt = (max) => {
  return Math.floor(Math.random() * max);
};
function reducer(state, action) {
  switch (action.type) {
    case 'event':
      {
        const id = getRandomInt(9999999999999).toString();
        return [{ ...action.data, id, date: Date.now() }, ...state];
      }
    default:
      throw new Error();
  }
}
const printBanner = (getEnvVar) => {
  let appCode = getEnvVar.APP_CODE;   //'RECL' | 'CRUD' | 'BITI' | 'NULC' | TMPL'  
console.info('=====================================================================================');
  console.info('==                                                                                 ==');
  console.info('== AppContext: *** !!! App: ' + appCode + ' - Mode: ' + getEnvVar.RUN_ENV + ' - Node Env: ' + getEnvVar.NODE_ENV + ' !!! ***       ==',
  );
  console.info('==                                                                                 ==');
  console.info('=====================================================================================');
}

function App(props) {
  const { type, appContext, routes, route } = props

  const [ getEnvVar, setGetEnvVar ] = useState();
  const [ setupState, setSetupState ] = useState();
  const [ appInitState, setAppInitState ] = useState();

  const [events, dispatch] = useReducer(reducer, []);   // Used for setupInitState:oidcConfig 
  let oidcConfig, fpidState, prefState, konsole;

  useEffect( () => {
    async function fetchData() {
      const appCode = import.meta.env.VITE_APP_CODE;
      const appEnv = import.meta.env.MODE;
      const appMode = import.meta.env.VITE_MODE;
      const appNodeEnv = import.meta.env.VITE_NODE_ENV;
      const appVersion = import.meta.env.VITE_APP_VERSION;
      const path = `/src/data/${appCode}_${appEnv}.js`;
      const options = { appCode, appEnv, appMode, appNodeEnv, appVersion, path };
      const envVar = await loadEnvVar(options);

      setGetEnvVar(envVar);
    }
    fetchData();
  }, []);   // Runs once 

  useEffect( () => {
    async function fetchData() {
      if (!getEnvVar) return;
      const setupStateTmp = await setupInitState(type, getEnvVar, dispatch);
      setSetupState(setupStateTmp);
    }
    fetchData();
  }, [getEnvVar]);   // Runs once 

  useEffect( () => {
    async function fetchData() {
      if (!getEnvVar || !setupState.oidcConfig || !setupState.fpidState || !setupState.prefState || !setupState.konsole) return;

      let appInitStateTmp = await createInitState(
	getEnvVar,
	appContext,
	setupState.fpidState,
	setupState.prefState,
	setupState.konsole,
	setupState.queryData,
      );

      appInitStateTmp = await manageUpap('fpid', appInitStateTmp, null);

      // Trigger getting location data TODO can be delayed until later (but needed for lawyer adverts)
      if (!appInitStateTmp.loc) {
	await appInitStateTmp.triggerDetectLocation(appInitStateTmp);
	console.log('App:location data : ' + JSON.stringify(appInitStateTmp.loc));
      }

      setAppInitState(appInitStateTmp)
    }
    fetchData();
  }, [setupState]);   // Runs once 

  if (!getEnvVar ||
    !getEnvVar.APP_CODE ||
    !setupState ||
    !appInitState) {
    return <h2> LOADING ... </h2>;
  }
  else {
    const Layout = () => {
      return (
	<ContentLayout
	  themes={themes}
	  appInitState={appInitState}
	  appReducer={appReducer}
	  headerOptions={siteData(getEnvVar, {type: 'headerOptions' })}
	  footerOptions={siteData(getEnvVar, {type: 'footerOptions' })}
	  oidcConfig={setupState.oidcConfig}
	  getEnvVar={getEnvVar} 
	>
	  <div data-where="App-Outlet">
	    <Outlet />
	  </div>
	</ContentLayout>
      );
    };

    const rts = [];
    for (let i = 0; i < routes.length; i++) {
      const r = routes[i];
      const path = r.path.substr(1);
      const element = r.element;
      if (r.path === '/') {
	rts.push(<Route key={'index'} index element={element} />);
      }
      else
	if (r.path === '*') {
	  rts.push(<Route key={'route-' + i} path={'*'} element={element}></Route>);
	}
      else {
	rts.push(<Route key={'route-' + i} path={path} element={element}></Route>);
      }
    }	

    printBanner(getEnvVar);

    if (type === 'client') {
      return (
	<BrowserRouter location={route}>
	  <Routes>
	    <Route path="/" element={<Layout />}>
	      { rts }
	    </Route>
	  </Routes>
	</BrowserRouter>
      );
    }   
    else {   // 'server'
      return (
	<StaticRouter location={route}>
	  <Routes>
	    <Route path="/" element={<Layout />}>
	      { rts }
	    </Route>
	  </Routes>
	</StaticRouter>
      );
    } 
  }
}

export default App
